import { useTranslations } from "use-intl";
import { useStoreState } from "../store/useStore";
import { dropDownStylesText, stylesGroupText } from "../styles";
import styles from "./index.module.scss";
import ArrowIcon from "../../assets/header/arrow.svg?react";
import CopyTradeIcon from "../../assets/header/copy-trade.svg?react";
import EarnAccountIcon from "../../assets/header/earn-account.svg?react";
import FundingIcon from "../../assets/header/funding.svg?react";
import FuturesAccountIcon from "../../assets/header/futures-account.svg?react";
import HistoryIcon from "../../assets/header/history.svg?react";
import AccountLine from "../../assets/header/account-line.svg?react";
import OrderIcon from "../../assets/header/order.svg?react";
import OverviewIcon from "../../assets/header/overview.svg?react";
import SpotIcon from "../../assets/header/spot.svg?react";
// import AuditsIcon from "../../assets/header/audits.svg?react";
import { AssetsProps } from "../types";
import { stylesBg } from "./styles";
import { useEffect, useMemo, useState } from "react";
import { cloneDeep } from "lodash";
import AssetsCard from "./AssetCard";

import useAction, { AccountMode, GetAccountModeResponse } from "../AccountMode/useAction";

const AssetsPopper = () => {
  const assets: AssetsProps[] = [
    {
      label: "overview",
      link: "assets/overview",
      icon: OverviewIcon,
      key: 0
    },
    {
      label: "funding",
      link: "assets/funding",
      icon: FundingIcon,
      key: 1
    },
    {
      label: "spotAccount",
      link: "assets/spot",
      icon: SpotIcon,
      key: 2,
      isSupportDemoTrading: true,
      isSupportSubAccount: true
    },
    {
      label: "futuresAccount",
      link: "assets/derivatives",
      icon: FuturesAccountIcon,
      key: 3,
      isSupportDemoTrading: true,
      isSupportSubAccount: true
    },
    {
      label: "trading",
      link: "assets/trading",
      icon: FuturesAccountIcon,
      key: 10,
      isSupportDemoTrading: true,
      isSupportSubAccount: true
    },
    {
      label: "copyTrading",
      link: "assets/copy-trading",
      icon: CopyTradeIcon,
      key: 4
    },
    {
      label: "earnAccount",
      link: "assets/earn",
      icon: EarnAccountIcon,
      key: 5
    },
    {
      key: 999,
      type: "line",
      label: "history",
      icon: <></>,
      link: ""
    },
    {
      label: "accountAnalysis",
      link: "assets/analysis",
      icon: AccountLine,
      key: 6,
      isSupportSubAccount: true
    },
    {
      label: "history",
      link: "assets/history",
      icon: HistoryIcon,
      key: 7,
      isSupportSubAccount: true
    },
    {
      label: "orderCenter",
      link: "assets/orders",
      icon: OrderIcon,
      key: 8,
      isSupportDemoTrading: true,
      isSupportSubAccount: true
    }
    // {
    //   label: "audits",
    //   link: "assets/audits",
    //   icon: AuditsIcon,
    //   key: 9,
    //   isSupportSubAccount: true
    // }
  ];

  const { theme, localeLink, isDemoTrading, userInfo } = useStoreState();

  const [visible, setIsVisible] = useState(false);

  const { getAccountMode } = useAction();

  const t = useTranslations("header");

  const [currentAccountMode, setCurrentAccountMode] = useState<AccountMode>("ACCOUNT_LEVEL_NORMAL");

  const initAccountMode = async () => {
    try {
      const res = await getAccountMode();
      const { code, msg, data } = res as unknown as {
        code: number;
        msg: string;
        data: GetAccountModeResponse;
      };
      if (code !== 200) {
        throw new Error(msg || "Get Account Mode Error");
      }
      setCurrentAccountMode(data.account_level);
    } catch (error) {
      console.log("Get Account Mode Error", error);
    }
  };

  const menus = useMemo(() => {
    let nav = cloneDeep(assets);

    if (isDemoTrading) {
      nav = nav.filter((item) => item.isSupportDemoTrading);
    }

    if (currentAccountMode === "ACCOUNT_LEVEL_NORMAL") {
      nav = nav.filter((item) => item.label !== "trading");
    } else {
      nav = nav.filter((item) => item.label !== "spotAccount" && item.label !== "futuresAccount");
    }

    if (userInfo?.account_type === "NORMAL_SUB_ACCOUNT") {
      nav = nav.filter((item) => item.isSupportSubAccount);
    }

    return nav;
  }, [currentAccountMode, isDemoTrading, userInfo?.account_type]);

  useEffect(() => {
    initAccountMode();
  }, []);

  return (
    <div
      className={`${styles["assets-container"]} group`}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}>
      <div
        className={`${styles["assets-text"]} ${stylesGroupText({
          mode: theme
        })}`}>
        {t("assets")}
        <ArrowIcon
          className={`${stylesGroupText({
            mode: theme
          })} group-hover:rotate-180 ml-[2px]`}
        />
      </div>
      <div
        className={`${stylesBg({
          mode: "light"
        })} shadow-[0_2px_20px_rgba(0,0,0,.12)] ${styles["asset-hover-animate"]}`}>
        <AssetsCard visible={visible} accountType={userInfo?.account_type}></AssetsCard>
        <div className="px-[12px] pb-[24px]">
          {menus.map((item, index) => {
            if (item?.type === "line")
              return <div className="my-[16px] w-full h-[1px] bg-light-line-primary"></div>;
            return (
              <a
                key={index}
                href={`${localeLink}/${item.link}`}
                className={`h-[44px] px-[12px] flex items-center text-[14px] font-medium cursor-pointer hover:bg-light-fill-primary hover:text-light-primary hover:rounded-[8px] ${dropDownStylesText(
                  {
                    mode: "light"
                  }
                )}`}>
                <item.icon className={styles["assets-icon"]} />
                {t(item.label)}
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AssetsPopper;
